import React, { useState, useEffect } from "react";
import { defaultStyles } from "../../../../../constants/style-constants/utils";
import IconInputTax from "../../../../styled-components/input/icon-input-tax";
import { Text } from "../../../../styled-components/text";
import * as Style from "./styles/capital-gains";
import { Button } from "../../../../styled-components/button";
import CarryForward from "../carry-forward/carry-forward";
import TaxCredits from "../tax-credits/tax-credits";
import { InputGroup } from "../../../../styled-components/input/styles/input";
import "../../styles/tax-inflation-style.css";

function CapitalGains({ handleTaxInflationObject, nextForm, preForm, data, taxInfo }) {
  const uniqueKey = Object.keys(data.capitalGains.data)[0];
  const capitalGainObj = data.capitalGains.data[uniqueKey];
  // const capitalGainObj = {
  //   subjectToCapGains: "",
  //   gainsRateFederal: "",
  //   gainsRateState: "",
  // };

  const capitalGainObjMain = {
    "Subject to Cap Gains": "50",
    "Gains Rate Federal": "80",
    "Gains Rate State": "10",
  };

  const [capitalGainData, setCapitalGainData] = useState({
    "Subject To Cap Gains":
      (capitalGainObj && capitalGainObj["Subject To Cap Gains"]),
    "Gains Rate Federal":
      (capitalGainObj && capitalGainObj["Gains Rate Federal"]),
    "Gains Rate State":
      (capitalGainObj && capitalGainObj["Gains Rate State"]) ,
  });

  const { styles } = defaultStyles;

  const handleCapitalGainInfo = (obj) => {
    const { name, value } = obj;

    setCapitalGainData({
      ...capitalGainData,
      [name]: value,
    });
  };
  useEffect(() => {
    if(taxInfo){
      setCapitalGainData({
        "Subject To Cap Gains": taxInfo && taxInfo.amountWithdrawnCapGains ? taxInfo.amountWithdrawnCapGains : "",
    "Gains Rate Federal": taxInfo && taxInfo.capGainsRateFederal ? taxInfo.capGainsRateFederal : "",
    "Gains Rate State": taxInfo && taxInfo.capGainsRateState ? taxInfo.capGainsRateState : "",
      })
    }
  }, [taxInfo]);

  const nextComponent = {
    name: "carryForward",
    title: "Carry Forward",
    unique: "matric",
    isMulti: false,
    component: CarryForward,
    carryForward: {},
  };

  const preComponent = {
    name: "taxCredits",
    title: "Tax Credits",
    unique: "Other Tax Credit",
    isMulti: true,
    component: TaxCredits,
    taxCredits: {},
  };

  const submitData = () => {
    handleTaxInflationObject(capitalGainData);
    nextForm(nextComponent);
  };

  const fields = [
    {
      Component: IconInputTax,
      value: {
        name: "Subject To Cap Gains",
        title: "Amount Withdrawn Subject To Cap Gains",
        icon: "%",
        value: capitalGainData["Subject To Cap Gains"],
        iconPosition: "end",
        onChange: (event) => handleCapitalGainInfo(event.target),
      },
    },
    {
      Component: IconInputTax,
      value: {
        name: "Gains Rate Federal",
        title: "Capital Gains Rate - Long Term",
        icon: "%",
        value: capitalGainData["Gains Rate Federal"],
        iconPosition: "end",
        onChange: (event) => handleCapitalGainInfo(event.target),
      },
    },
    {
      Component: IconInputTax,
      value: {
        name: "Gains Rate State",
        title: "Capital Gains Rate - Short Term",
        icon: "%",
        value: capitalGainData["Gains Rate State"],
        iconPosition: "end",
        onChange: (event) => handleCapitalGainInfo(event.target),
      },
    },
  ];

  return (
    <Style.MainContainer>
      <h3 style={{ color: "#2a3da3", fontWeight: "600", fontSize: "28px" }}>
      Capital Gains 
      </h3>

      <Style.FieldsContainer>
      {fields &&
        fields.map((data, index) => {
          const { value, Component, name, title, type, onChange } = data;
          return (
            <InputGroup key={index} style={{width:"30%"}}>
              <Text style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                {title || value.title}
              </Text>

              <Component
                key={index}
                value={value}
                name={name}
                onChange={onChange}
                type={type}
              />
            </InputGroup>
          );
        })}
    </Style.FieldsContainer>
      <Style.ButtonsContainer>
        <button
          className="tax-inflation-prev-button"
          onClick={() => preForm(preComponent)}>
          Previous
        </button>
        <button className="tax-inflation-next-button" onClick={submitData}>
          Next
        </button>
      </Style.ButtonsContainer>
    </Style.MainContainer>
  );
}

export default CapitalGains;
